import { render, staticRenderFns } from "./ViewJob.vue?vue&type=template&id=77b581c6&scoped=true&"
import script from "./ViewJob.vue?vue&type=script&lang=ts&"
export * from "./ViewJob.vue?vue&type=script&lang=ts&"
import style0 from "./ViewJob.vue?vue&type=style&index=0&id=77b581c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b581c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSkeletonLoader})
